export const colors = {
  defaultBg: "#ebebeb",
  cardBg1: "#050926",
  cardBg2: "#151a40",
  cardBg3: "#2c315c",
  orange: "#fa8a12", // #fe840e
  green: "#62f98e",
  lightRed: "#ff8d8c",
  red: "#cd212a",
  lightGold: "#ffdc4e",
  5: "#ffd700",
  4: "#e32eff",
  3: "#8bb6ff",
  2: "#49e03e",
  1: "Gray",
  Pyro: "#ff504a",
  Hydro: "#2eaaff",
  Dendro: "#49e03e",
  Electro: "#cd77ff",
  Anemo: "#48ffce",
  Cryo: "#75faff",
  Geo: "#ffc558",
  black: "#000",
  white: "#fff"
};

export const fontSizes = {
  h1: "2rem",
  h2: "1.75rem",
  h3: "1.5rem",
  h4: "1.375rem",
  h5: "1.25rem",
  h6: "1.125rem",
  p: "1rem",
  subtitle1: "0.875rem"
};

export const lineHeights = {
  h1: 1.167,
  h2: 1.2,
  h3: 1.167,
  h4: 1.235,
  h5: 1.334,
  h6: 1.6,
  p: 1.5,
  subtitle1: 1.43
};
